function fraudCheckConfig($routeSegmentProvider) {
    $routeSegmentProvider.
        when('/merchant/fraudcheck', 'merchantFraudCheck').
        segment('merchantFraudCheck', {
            template: require('../merchant-fraud-check.html'),
            controller: 'MerchantFraudCheckController',
            controllerAs: 'vm',
            resolve: {
                fraudCheckData(merchantService, messageService) {
                    'ngInject';
                    return merchantService.loadMerchantInfo()
                        .then(merchant => {
                            /* eslint promise/no-nesting:0 */
                            return merchantService
                                .getFraudCheckConfigurationByMerchant(merchant.id)
                                .then( responseFraud => Object.assign(responseFraud, {merchantId: merchant.id}))
                                .catch(reason => messageService.error(reason));
                        })
                        .catch(reason => messageService.error(reason));
                }
            },
            untilResolved: {
                template: require('../../shared/loading-screen.html')
            },
            resolveFailed: {
                template: require('../../shared/loading-error.html')
            }
        });
}
angular
    .module('qkr.fraud.check')
    .config(fraudCheckConfig);




// WEBPACK FOOTER //
// ./src/fraud-check/config/fraud.check.config.js